import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Grid, Row, Col } from "react-bootstrap";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import EmailIcon from "@material-ui/icons/EmailOutlined";

import ImportExport from "@material-ui/icons/ImportExport";
import Paper from "@material-ui/core/Paper";
import "typeface-roboto";
import Modal from "react-modal";
import OpdrachtForm from "./OpdrachtForm";
import "../react-confirm-alert.css";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)"
  }
};
const styles = {
  containerModal: {
    display: "flex",
    flexWrap: "wrap",
    fontSize: 14
  },
  container: {
    display: "flex",
    flexDirection: "column"
  },
  row: {
    display: "flex",
    flexDirection: "row"
    //alignItems: "center"
  },
  checkbox: {
    marginLeft: 16,
    width: 40
  },
  input: {
    flex: 1
    //alignContent: "flex-start",
    //justifyContent: "flex-start"
  },
  icongreen: {
    marginRight: 6,
    color: "green"
  },
  iconred: {
    marginRight: 6,
    color: "red"
  },
  subtitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "blue",
    paddingRight: 30
  },
  naam: {
    width: "90%"
    //alignSelf: "flex-start"
  },
  sluitbutton: {
    backgroundcolor: "#00FF00"
  }
};

const myVrijwilliger = {
  marginTop: 0,
  marginLeft: 20,
  //width: 200,
  float: "left",
  color: "blue"

  //fontSize: "24"
  //width: "80%"
};

class Opdracht extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      module: ""
    };
    this.openModal = this.openModal.bind(this);
    //this.openModalOpdracht = this.openModalOpdracht.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true, module: "wijzigenOpdracht" });
  }
  // openModalOpdracht() {
  //   this.setState({ modalIsOpen: true, module: 'opdrachten' });
  // }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.subtitle.style.color = "blue";
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }
  static propTypes = {
    opdracht: PropTypes.any
  };

  handleChange = name => event => {
    const { opdracht, gebruikersNaam } = this.props;
    opdracht.update({
      [name]: event.target.value,
      zz_lastupdate:
        new Date().toLocaleDateString("nl-NL") +
        " " +
        new Date().toLocaleTimeString("nl-NL"),
      zz_gebruikersNaam: gebruikersNaam
    });
  };

  render() {
    const { opdracht, gebruikersNaam, gebruikersrollen } = this.props;
    const {
      voornaam,
      tussenvoegsel,
      achternaam,
      typeopdracht,
      zz_lastupdate,
      zz_gebruikersNaam
    } = opdracht.data;

    //console.log("TodoItem.render: ", vrijwilliger.path, ", text: ", text);
    return (
      <div>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={[customStyles, "pre-scrollable"]}
          contentLabel="Wijzig opdracht"
        >
          <h3
            style={styles.subtitle}
            ref={subtitle => (this.subtitle = subtitle)}
          >
            {/* <Button variant="contained" color="primary" onClick={this.closeModal} style={{ marginRight: 20 }}>
              Sluit dit venster
            </Button>{' '} */}
            Wijzigen opdracht {typeopdracht} voor : {voornaam}{" "}
            {tussenvoegsel || ""} {achternaam || ""}
          </h3>
          <div>
            {this.state.module === "wijzigenOpdracht" && (
              <OpdrachtForm
                opdracht={opdracht}
                gebruikersNaam={gebruikersNaam}
                gebruikersrollen={gebruikersrollen}
              />
            )}
            {/* {this.state.module === 'opdrachten' && (
              <Opdracht
                klant={klant}
                opdracht={opdracht}
                gebruikersNaam={gebruikersNaam}
                gebruikersrollen={gebruikersrollen}
              />
            )} */}
          </div>
          <p />
          <Button variant="contained" color="primary" onClick={this.closeModal}>
            Annuleer
          </Button>
          <h5 style={{ color: "#cecece", fontSize: 9 }}>
            Laatst gewijzigd door: {zz_gebruikersNaam} op {zz_lastupdate} id ={" "}
            {opdracht.id}
          </h5>
          <form />
        </Modal>
        <Paper zdepth={1}>
          <Grid>
            <Row>
              <Col xs={1} sm={1} lg={1} xl={1}>
                {" "}
                {gebruikersrollen.search("admin") > -1 && (
                  <Button
                    style={styles.iconred}
                    onClick={this.onPressDelete}
                    color="red"
                  >
                    <DeleteIcon /> Verwijder
                  </Button>
                )}
              </Col>
              {/* <Col xs={1} sm={1}>
                <Button onClick={this.openModal}>
                  <EditIcon />
                </Button>
              </Col> */}
              <Col
                xs={5}
                sm={5}
                lg={5}
                xl={5}
                style={myVrijwilliger}
                bsClass="float-left"
                onClick={this.openModal}
              >
                <Button style={styles.icongreen} onClick={this.openModal}>
                  <EditIcon /> Wijzig opdracht voor {voornaam || ""}{" "}
                  {tussenvoegsel || ""} {achternaam || ""}.
                </Button>
              </Col>
              <Col
                xs={5}
                sm={5}
                lg={5}
                xl={5}
                style={myVrijwilliger}
                bsClass="float-left"
                // onClick={this.openModal}
              >
                {gebruikersrollen.search("pierre") > -1 &&
                  typeopdracht.startsWith("Chauffeur") && (
                    <Button
                      style={styles.icongreen}
                      onClick={this.isRetourGeboekt}
                    >
                      <ImportExport />Deze opdracht is reeds retourgeboekt of
                      enkele reis van {voornaam || ""} {tussenvoegsel || ""}{" "}
                      {achternaam || ""}.
                    </Button>
                  )}
              </Col>
              <Col
                xs={5}
                sm={5}
                lg={5}
                xl={5}
                style={myVrijwilliger}
                bsClass="float-left"
                onClick={this.openModal}
              >
                <Button style={styles.icongreen} onClick={this.setNoMail}>
                  <EmailIcon filled /> Stop mail versturen voor deze opdracht
                  van {voornaam || ""} {tussenvoegsel || ""} {achternaam || ""}.
                </Button>
              </Col>

              {/* <Col
                xs={5}
                sm={5}
                lg={5}
                xl={5}
                style={myVrijwilliger}
                bsClass="float-left"
                onClick={this.openModalOpdracht}
              >
                Klik hier om opdracht in te voeren voor {voornaam || ''} {tussenvoegsel || ''} {achternaam || ''}.
              </Col> */}
            </Row>
          </Grid>
          <Divider />
        </Paper>
      </div>
    );
  }

  onPressDelete = async () => {
    if (window.confirm("Weet u zeker dat u deze opdracht wilt verwijderen?")) {
      const { opdracht } = this.props;
      if (this._deleting) return;
      this._deleting = true;
      try {
        // if (klant.data.rollen) {
        //   alert(
        //     "Klant heeft rollen (" +
        //       klant.data.rollen +
        //       ") en kan niet verwijderd worden. Contact Pierre!!"
        //   );
        // } else {
        await opdracht.delete();
        this._deleting = false;
        // }
      } catch (err) {
        this._deleting = false;
      }
    }
  };

  setNoMail = async () => {
    const { opdracht } = this.props;
    await opdracht.update({
      nomail: true
    });
  };

  isRetourGeboekt = async () => {
    const { opdracht } = this.props;
    await opdracht.update({
      nomail: opdracht.geemaild || false,
      retourgeboekt: true
    });
  };

  onPressCheck = async () => {
    const { opdracht } = this.props;
    await opdracht.update({
      finished: !opdracht.data.finished
    });
  };

  onTextChange = async event => {
    const { opdracht } = this.props;
    await opdracht.update({
      text: event.target.value
    });
  };
}

export default observer(Opdracht);



// WEBPACK FOOTER //
// ./src/components/Opdrachten/Opdracht.jsx